/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const JsonCreateTenantParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['abbreviatedName', codecString, 'abbreviated_name'],
    ['hubspotCompanyId', /* #__PURE__ */ codecOptional(codecString), 'hubspot_company_id'],
]);
export class JsonCreateTenant extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JsonCreateTenantParser.decode(input).map(res => new JsonCreateTenant(res));
    }
    static unsafeDecode(input) {
        return JsonCreateTenant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JsonCreateTenantParser.encode(data);
    }
    static schema() {
        return JsonCreateTenantParser.schema();
    }
}
